import React, {useState, useEffect} from "react";
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/resources_banner.png";
import { useParams, Link } from "react-router-dom";
import instance from "../../../services/services";
import { BOARD_DETAIL_URL } from "../../../utils/urls";
function NoticeDetail(){
  // 0: Notice, 1: FAQ, 2: 자료실, 3:Blog
  const [activeTab, setActiveTab] = useState(0);
  const {b_seq} = useParams();
  const [notice, setNotice] = useState(null);

  // 배너 탭
  const tabList = [
    { label : 'Notice', url : '/resources/notice'},
    { label : 'FAQ', url : '/resources/faq'},
    { label : '자료실', url : '/resources/data'},
    { label : 'Blog', url : '/resources/blog'},
  ]
  

  useEffect(()=> {
    const fetchNoticeDetail = async () => {
      try{
        const response = await instance.post(BOARD_DETAIL_URL, {
          b_seq: b_seq,
          boardid: "notice"
        });
        setNotice(response.data.data);
      } catch (error) {
        console.error('게시판 상세 조회 오류:', error);
      }
    };
    fetchNoticeDetail();
  }, [b_seq]);



  return(
    <div className="resources">
      {/* 배너 */}
      <SubBanner
          bgImg={bannerImg}
          title= {'Notice'}
          tabs={tabList.map((tab,idx) => ({
            label : tab.label,
            url : tab.url,
            active: activeTab === idx,
            onClick: () => setActiveTab(idx),
          }))}
          location={[
            { label: "Resources", url: "/resources" },
            { label: "Notice", url: "/resources/notice", active: true }
          ]}
        />

      <section className="sub_section mt-[170px] mb-[80px] mx-auto">
        <h3 className="detial_title pb-[32px]">Notice</h3>
        {/* 공지사항 타이틀 */}
        <div className="flex items-center p-[16px] gap-[16px] border-b-[1px] border-b-[#E8E8E8]">
          <span className="notice_badge">공지</span>
          <div className="notice_title">
            <h4>{notice?.subject}</h4>
            <span className="mt-[4px]">{notice?.regist_date?.split(' ')[0]}</span>
          </div>
        </div>

        {/* 공지사항 컨텐츠 */}
        <div className="notice_con unset py-[40px] px-[16px] border-b-[1px] border-b-[#E8E8E8]">
          <div dangerouslySetInnerHTML={{__html: notice?.contents}}></div>
        </div>

        {/* pdf */}
        {notice?.fileList && notice.fileList.length > 0 && (
          <div className="notice_file py-[16px] px-[24px] border-b-[1px] border-b-[#E8E8E8]">
            <ul className="flex flex-col gap-[8px]">
              {notice?.fileList?.map((file,idx)=>(
                <li 
                  className="flex items-center gap-[4px] cursor-pointer" 
                  key={idx}
                  onClick={() => window.open(`https://admin.nhnace.com${file.file_path}`, '_blank')}
                >
                  <i className="icon icon_detail_clip"></i>
                  <span className="underline">{file.file_name}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* 목록 */}
        <div className="list_btn mt-[32px] flex justify-center">
          <Link to="/resources/notice">
            <button type="button">목록</button>
          </Link>
        </div>

      </section>
    </div>
  )
};

export default NoticeDetail;